<template>
  <div class="mb-4 col-xl-3 col-md-6 mb-xl-0">
    <div class="position-relative default-project-card" style="min-height: 300px;">
      <router-link :to="action?.route || '#'" class="shadow-lg d-block border-radius-xl text-center">
        <!-- 이미지가 정상일 때 -->
        <img
          v-if="!imgError && image"
          :src="image"
          class="border-radius-md card-image"
          @error="onImgError"
          alt="thumbnail"
        />
        <!-- 이미지가 없거나 에러일 때 -->
        <div v-else class="no-image border-radius-md">
          <svg viewBox="0 0 48 48" width="44" height="44" aria-hidden="true">
            <circle cx="24" cy="24" r="22" fill="none" stroke="#cbd5e1" stroke-width="2"/>
            <path d="M16 30l6-7 5 6 7-9 6 10" fill="none" stroke="#cbd5e1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <circle cx="18" cy="18" r="3" fill="#cbd5e1"/>
          </svg>
          <div class="no-image-text">No image</div>
        </div>
      </router-link>
    </div>

    <div class="px-1 pb-0 card-body">
      <p class="mb-2 text-sm text-gradient text-dark">{{ label }}</p>
      <a href="javascript:;"><h5>{{ title }}</h5></a>
      <p class="mb-3 text-sm">{{ description }}</p>
      <div class="d-flex align-items-center justify-content-between">
        <button
          type="button"
          class="mb-0 btn btn-sm"
          :class="`btn-outline-${action?.color || 'secondary'}`"
          @click="goAction"
        >
          {{ action?.label || 'View' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DefaultProjectCard",
  props: {
    image: { type: String, default: "" },
    label: { type: String, default: "" },
    title: { type: String, default: "Default Project Card" },
    description: { type: String, default: "" },
    action: {
      type: Object,
      default: () => ({ route: "/", color: "secondary", label: "View" })
    }
  },
  data() {
    return { imgError: false };
  },
  methods: {
    onImgError() { this.imgError = true; },
    goAction() {
      if (!this.action || !this.action.route) return;
      const to = typeof this.action.route === "string" ? { path: this.action.route } : this.action.route;
      this.$router.push(to);
    }
  }
};
</script>

<style scoped>
.default-project-card {
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}
.default-project-card:hover {
  transform: scale(1.03);
  box-shadow: 0 8px 20px rgba(0,0,0,0.15);
}
.card-image {
  max-width: 100%;
  height: 300px;
  object-fit: cover; /* 이미지 비율 유지하면서 꽉 채움 */
  display: block;
  width: 100%;
}

/* 플레이스홀더 */
.no-image {
  height: 300px;
  width: 100%;
  background:
    radial-gradient(circle at 20% 20%, #f8fafc 0 40%, transparent 41%) 0 0/40px 40px,
    linear-gradient(180deg, #f1f5f9, #f8fafc);
  border: 1px dashed #e2e8f0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  gap: 8px;
}
.no-image-text {
  font-size: 12px;
  letter-spacing: .2px;
}
</style>
